<template>
  <div ref="chartWrapper"></div>
</template>

<script>
export default {
  mounted() {
    // force re draw chart after modal is shown
    $(document).on("shown.bs.modal", e => {
      this.chart.flush();
    });

    // create the chart
    this.chart = c3.generate({
      bindto: this.$refs.chartWrapper,
      data: {
        json: this.data,
        keys: {
          x: "date",
          value: ["value"]
        },
        type: "area-spline",
        color: () => {
          return this.colors[this.color];
        }
      },

      // options --------
      size: {
        height: undefined,
        width: undefined
      },
      padding: {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
      },
      interaction: {
        enabled: true
      },
      point: {
        show: true
      },
      subchart: {
        show: true
      },
      grid: {
        x: {
          show: false
        },
        y: {
          show: true
        }
      },
      axis: {
        x: {
          show: true,
          type: "category",
          tick: {
            rotate: 30,
            multiline: false,
            culling: true
            // format: "%Y-%m-%d"
            // format: function (x) {
            //   let date = new Date(x);
            //   return `${date.getMonth() - 1}/${date.getFullYear()}`;
            // },
          }
        }
      },
      legend: {
        hide: true
      }
    });
  },
  props: ["data", "color"],
  data() {
    return {
      chart: null,
      colors: {
        green: "#008561",
        danger: "#FF5758"
      }
    };
  }
};
</script>
<style lang="scss"></style>
